class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 300);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static isCollectionPage() {
    return window.location.pathname.includes('/collections/');
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const cleanParams = new URLSearchParams(searchParams);
    cleanParams.delete('filter.v.availability');
    const cleanSearchParams = cleanParams.toString();

    const isCollection = FacetFiltersForm.isCollectionPage();
    const fetchParams = new URLSearchParams(cleanSearchParams);
    if (isCollection) fetchParams.set('filter.v.availability', '1');
    const fetchSearchParams = fetchParams.toString();

    // On collection pages, persist availability in the URL when filters are active
    // so a page refresh shows the same in-stock-only results.
    const urlSearchParams = isCollection && cleanSearchParams ? fetchSearchParams : cleanSearchParams;

    FacetFiltersForm.searchParamsPrev = urlSearchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${fetchSearchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(urlSearchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsedHtml.getElementById('ProductCount');
    const count = countEl ? countEl.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    // Update Button Apply
    const footerEl = parsedHtml.getElementById('mobile-facets__footer-custom');
    const containerBtn = document.getElementById('mobile-facets__footer-custom');
    if (container) container.innerHTML = count;
    if (containerBtn && footerEl) {
      containerBtn.innerHTML = footerEl.innerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.removeForceAvailabilityChip();
  }

  // Strips the silently-injected availability active-filter chip from the UI.
  // The chip's remove-href does NOT contain filter.v.availability (removing it would undo our injection);
  // every other chip's remove-href retains filter.v.availability=1 since it stays active.
  static removeForceAvailabilityChip() {
    document.querySelectorAll('.active-facets facet-remove:not(.active-facets__button-wrapper)').forEach((el) => {
      const link = el.querySelector('a[href]');
      if (!link) return;
      if ((link.getAttribute('href') || '').indexOf('filter.v.availability') === -1) el.remove();
    });
  }

  // On page init the server renders filter counts for all products (including OOS).
  // This fetch replaces only the filter option groups with availability-scoped counts
  // so users only see and click filters that will actually return results.
  // The product grid is left untouched — server-rendered, shows all products.
  static initAvailabilityFilteredFacets() {
    if (!FacetFiltersForm.isCollectionPage()) return;
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id) return;

    document.body.classList.add('facets-counts-pending');

    const initParams = new URLSearchParams(window.location.search);
    initParams.delete('filter.v.availability');
    initParams.set('filter.v.availability', '1');
    const fetchUrl = `${window.location.pathname}?section_id=${grid.dataset.id}&${initParams.toString()}`;

    fetch(fetchUrl)
      .then((r) => r.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        parsed.querySelectorAll(
          '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        ).forEach((fetchedEl) => {
          const domEl = document.getElementById(fetchedEl.id);
          if (domEl) domEl.innerHTML = fetchedEl.innerHTML;
        });
        const menuDrawer = document.querySelector('menu-drawer');
        if (menuDrawer && typeof menuDrawer.bindEvents === 'function') menuDrawer.bindEvents();
        document.body.classList.remove('facets-counts-pending');
      })
      .catch(() => { document.body.classList.remove('facets-counts-pending'); });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initAvailabilityFilteredFacets();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeSliderPrice();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this))
    });
    this.setMinAndMaxValues();
    const numberS = this.querySelectorAll("input[type=number]");
    let value1 = numberS[0].value;
    let value2 = numberS[1].value ;

    this.updateDisplay(value1, value2);

    this.debouncedOnSubmit = debounce((event,index) => {
      this.onTextInputChange(event,index);
    }, 1000);
    const textInputs = this.querySelectorAll(".field__input--change");
    textInputs.forEach((input, index) => {
      input.addEventListener("input", (e) => {
        // this.debouncedOnSubmit(e,index);
        this.onTextInputChange(e, index);
      });
    });
  }

  onTextInputChange(event, index) {
    const value = parseFloat(event.target.value.replace(/[^\d]/g, '')) || 0;
    const rangeS = this.querySelectorAll("input[type=range]");
    const numberS = this.querySelectorAll("input[type=number]");

    numberS[index].value = value;
    rangeS[index].value = value;

    let v1 = parseFloat(numberS[0].value);
    let v2 = parseFloat(numberS[1].value);

    // if (v1 > v2) [v1, v2] = [v2, v1];
    // this.adjustToValidValues(event.currentTarget);
    this.updateDisplay(v1, v2);
    // this.updatePrice(v1, v2);
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  rangeSliderPrice(){
    var rangeS = this.querySelectorAll("input[type=range]"),
        numberS = this.querySelectorAll("input[type=number]");

    rangeS.forEach((element) => {
      element.oninput = () => {
        var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);

        if (slide1 > slide2) {
          [slide1, slide2] = [slide2, slide1];
        }

        numberS[0].value = slide1;
        numberS[1].value = slide2;
        this.updateDisplay(numberS[0].value, numberS[1].value);
        this.updatePrice(slide1, slide2);
      }
    });
  }

  updateDisplay(value1, value2) {
    const range = this.querySelector("input[type=range]");
    const priceSlideRangeContainer = this.querySelector('.facets__price--slide');
    const max = range.max
    // // const width = priceSlideRangeContainer.clientWidth;
    let width = 296;
    if(window.screen.width > 767) {
      width = 272;
    }

    const leftSpace = (parseInt(value1) / parseInt(max)) * width + 'px'
    const rightSpace = (width - (parseInt(value2) / parseInt(max)) * width) + 'px'

    priceSlideRangeContainer.style.setProperty('--left-space', leftSpace)
    priceSlideRangeContainer.style.setProperty('--right-space', rightSpace)
  }

  updatePrice(min, max) {
    const $currentMin = this.querySelector('.money--current-min');
    const $currentMax = this.querySelector('.money--current-max');
    const priceInputMin = this.querySelector(".field__input-min");
    const priceInputMax = this.querySelector(".field__input-max");
    // const $labelMin = document.querySelector('.label__filter-min .text');
    // const $labelMax = document.querySelector('.label__filter-max .text');

    if ($currentMin) $currentMin.innerHTML = min;
    if ($currentMax) $currentMax.innerHTML = max;
    if (priceInputMin) priceInputMin.value = min;
    if (priceInputMax) priceInputMax.value = max;
    // if ($labelMin) $labelMin.innerHTML = min;
    // if ($labelMax) $labelMax.innerHTML = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
function initMobileStickyToolbar() {
  const toolbar = document.querySelector('#main-collection-filters') || document.querySelector('#main-search-filters');
  if (!toolbar) return;

  const anchorTop = toolbar.offsetTop;

  window.addEventListener('scroll', () => {
    if (window.scrollY >= anchorTop) {
      toolbar.classList.add('is-fixed');
    } else {
      toolbar.classList.remove('is-fixed');
    }
  }, { passive: true });
}

document.addEventListener('DOMContentLoaded', initMobileStickyToolbar);